'use strict';
var __importDefault =
	(this && this.__importDefault) ||
	function (mod) {
		return mod && mod.__esModule ? mod : {default: mod};
	};
Object.defineProperty(exports, '__esModule', {value: true});
exports.ordersByUser = void 0;
const graphql_tag_1 = __importDefault(require('graphql-tag'));
const checkout_1 = require('../fragments/checkout');
exports.ordersByUser = graphql_tag_1.default`
  ${checkout_1.checkoutFragment}
  query OrdersByUser($perPage: Int!, $after: String) {
    me {
      id
      checkout {
        ...Checkout
      }
      orders(first: $perPage, after: $after) {
        pageInfo {
          hasNextPage
          endCursor
        }
        edges {
          node {
            id
            token
            number
            statusDisplay
            created
            orderReference
            total {
              gross {
                amount
                currency
              }
              net {
                amount
                currency
              }
            }
            lines {
              id
              variant {
                id
                product {
                  name
                  id
                  leadTime
                  merchant {
                    id
                    name
                    storeHourStart
                    storeHourEnd
                    operatingDays
                    storeTitle
                    storeDescription
                    slug
                    logo {
                      url
                    }
                    warehouses (first: 5) {
                      edges {
                        node {
                          name
                          companyName
                          address {
                            streetAddress1
                            streetAddress2
                            latitude
                            longitude
                            city
                            phone
                            email
                          }
                        }
                      }
                    }
                  }
                }
              }
              thumbnail {
                alt
                url
              }
              thumbnail2x: thumbnail(size: 510) {
                url
              }
            }
            deliveryStatus
          }
        }
      }
    }
  }
`;
//# sourceMappingURL=orders.js.map
